import MenuItem from '@mui/material/MenuItem'
import React, { FC, useEffect, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { ChargeException } from '../../../../api/models/ChargeException.type'
import { suppliersAPI } from '../../../../api/supplier/suppliersAPI'
import FormSelect from '../../../FormFields/Select/FormSelect'

interface Item {
  value: string | number
  label: string
}
interface SelectProps {
  name: string
  label: string
}
const ChargeExceptionSelect: FC<SelectProps> = (props) => {
  const { name, label } = props
  const [options, setOptions] = useState<Array<Item>>([])
  const supplierId = useSelector((state: any) => state.suppliers.supplier.id)
  const chargeExceptionsResponse = useQuery({
    queryKey: ['getChargeExceptions', supplierId],
    queryFn: async () => suppliersAPI.getChargeExceptions(supplierId),
    refetchOnWindowFocus: false,
  })
  useEffect(() => {
    if (chargeExceptionsResponse) {
      let options: Item[] = []
      chargeExceptionsResponse?.data?.data.value.map(
        (chargeException: ChargeException) => {
          options.push({
            value: chargeException.id || 0,
            label: chargeException.name,
          })
        },
      )
      setOptions(options)
    }
  }, [chargeExceptionsResponse])

  return (
    <FormSelect name={name} label={label}>
      {options.map((option) => {
        return (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        )
      })}
    </FormSelect>
  )
}

export default ChargeExceptionSelect
